import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ClaimState {
  claimId: string | undefined;
  serviceContact: string | undefined;
  isMotionsCloudEnabled: boolean | undefined;
}

const initialState: ClaimState = {
  claimId: undefined,
  serviceContact: undefined,
  isMotionsCloudEnabled: undefined,
};

const claimSlice = createSlice({
  name: 'claim',
  initialState,
  reducers: {
    saveClaimId: (state: ClaimState, action: PayloadAction<string>) => {
      state.claimId = action.payload;
    },
    clearClaimId: (state: ClaimState) => {
      state.claimId = undefined;
    },
    setServiceContactForClaim: (state: ClaimState, action: PayloadAction<string | undefined>) => {
      state.serviceContact = action.payload;
    },
    setIsMotionsCloudEnabled: (state: ClaimState, action: PayloadAction<boolean>) => {
      state.isMotionsCloudEnabled = action.payload;
    },
  },
});

const { actions, reducer } = claimSlice;

export const { saveClaimId, clearClaimId, setServiceContactForClaim, setIsMotionsCloudEnabled } =
  actions;

export default reducer;
